import { challengeRef } from 'lib/firebase';

const attachTasksToChallenge = (tasksKeysObject, challengeKey) =>
  challengeRef(challengeKey).child('tasks').set(tasksKeysObject);

export default attachTasksToChallenge;
